import { QueovalBase, QueovalDate } from '../global';
import { Select } from '../utilities';
import { ActionCoActionCo, ActionCoContact, ActionCoDevis, ActionCoProject } from './action-co-devis.model';
import { Corporation } from './action-co.model';


export class ActionCoTransformModel extends QueovalBase {

  public ActionCo: ActionCoActionCo;
  public Project: ActionCoProject;
  public Devis: ActionCoDevis;

  public Financeur: Corporation;
  public PersonneMorale: Corporation;

  public ListContact: Array<ActionCoContact>;
  public ListContactPrincipal: Array<ActionCoContact>;

  public ModeTransform: ModeTransformation;

  public DataLigneDevis: ActionCoTransformData;
  public DataTransformation: Array<ActionCoTransformData>;

  /*public DataCVT: ActionCoTransformData;
  public DataAFFA: ActionCoTransformData;
  public DataPRESTA: ActionCoTransformData;*/

  public ListCntAffa: Array<string>;
  public CountLigneDevisTransforms: Array<CountLigneDevisTransform>;

  constructor() {
    super();
    this.ActionCo = new ActionCoActionCo();
    this.Project = new ActionCoProject();
    this.Devis = new ActionCoDevis();
    this.DataTransformation = new Array<ActionCoTransformData>();
    this.CountLigneDevisTransforms = new Array<CountLigneDevisTransform>();
  }
}


export class ActionCoTransformData {
  public IsDirty: boolean;
  public ModeTransform: ModeTransformation;
  public LigneDevis: Array<LigneDevisTransform>;
  public PrestaAffaireLock: boolean;
  public Convention: Select
  public Affaires: Array<ActionCoAffaire>;

  constructor() {
    this.IsDirty = true;
    this.LigneDevis = new Array<LigneDevisTransform>();
    this.PrestaAffaireLock = false;
    this.Convention = new Select();
    this.Affaires = new Array<ActionCoAffaire>();

  }
}

export class LigneDevisTransform {

  public Ident: string;
  public TypeLigne: TypeLigneDevis;
  public CurrentTypeLigne: TypeLigneDevis;
  public Designation: string;
  public Information: string;

  public Quantite: number;
  public PrixUnitaire: number;
  public Remise: number;

  public MontantRemiseHT: number;
  public MontantRemiseTTC: number;
  public MontantRemiseTVA: number;

  public MontantHT: number;
  public MontantTTC: number;
  public MontantTVA: number;

  public MontantHTAvantRemise: number;
  public MontantTTCAvantRemise: number;
  public MontantTVAAvantRemise: number;

  public TauxTVA: string;

  public IdStage: string;
  //public IdResa: string;
  public ListResa: Array<string>;

  public IdAffa: string;
  public IdProduit: string;
  public IdAction: string;

  public IdPrestation: string;

  public InfoStageInter: StageInter;
  public ListStageInter: Array<StageInter>;
  public StageState: StageState;

  public Selected: boolean;
  public Locked: boolean;
  public AsLigneDeFrais: boolean;

}

export class StageInter {
  public Value: string;

  public IdStage: string;
  public IdResa: string;

  public Selected: boolean;
  public Locked: boolean;

  public TypeStage: string;
  public Intitule: string;
  public Reservation: string;
  public DateDebut: string;
  public DateFin: string;
  public Cycles: string;
}

export class CountLigneDevisTransform {
  public LigneLabel: string;
  public Count: number;
}

export class ActionCoAffaire extends Select {
  public Selected: boolean;
}

export class LigneDevisFooterTranform {
  public Acompte: number;
  public Remise: number;
  public HT: number;
  public TVA: number;
  public TTC: number;

  constructor() {
    this.Acompte = 0;
    this.Remise = 0;
    this.HT = 0;
    this.TVA = 0;
    this.TTC = 0;
  }
}

export enum ModeTransformation {
  CONVENTION,
  AFFAIRE,
  PRESTATION,
}

export enum TypeLigneDevis {
  INTRA,
  INTER,
  INTRAINTER,
  AFFAIRE,
  PRESTATION,
  FRAIS
}

export enum StageState {
  NULL,
  OK,
  EXPIRED,
  NOSTAGE,
  INTRA,
  FRAIS,
  CREATED,
}
